import React from 'react'

const ModalBatalInspeksi = ({showBatalInspeksi, handleCloseBatalInspeksi, dataPpmKapal, dataDisposisi, reloadList, isEdit}) => {
    return (
        <>
        </>
    )
}

export default ModalBatalInspeksi